import React from 'react';
import {Typography} from '@material-ui/core';

export default function Title({myClasses, children, ...props}) {
  return (
    <Typography component="h1" variant="h6" className={myClasses} {...props} gutterBottom>
      {children}
    </Typography>
  );
}